import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Text, Dialog as PaperDialog, Portal, Provider as PaperProvider, Searchbar } from 'react-native-paper';
import { Platform, ScrollView, StyleSheet } from 'react-native';

import {
  search,
  deleteSearchDialog
} from '../actions';

class SearchDialog extends Component {
  state = {
    searchText: ''
  };
  _hideDialog = () => this.props.dispatch(deleteSearchDialog());

  handlerSearch = (text) => {
    const { searchDialog } = this.props;
    this.setState({ searchText: text });

    let lib = searchDialog.block.elements[0].value;
    this.props.dispatch(search({ text, lib }));
  }

  handlerChange = (item) => {
    const { searchDialog, onChange } = this.props;
    this.props.dispatch(deleteSearchDialog());

    onChange && onChange({
      block: searchDialog.block,
      value: item.id,
      label: item.name
    });
  }

  render() {
    const { searchDialog, searchResult } = this.props;
    const { searchText } = this.state;

    return (
      searchDialog.visible ? <PaperProvider>
        <Portal>
          <PaperDialog
            style={styles.paper}
            visible={searchDialog.visible}
            onDismiss={this._hideDialog}>
            {/* <PaperDialog.Title>{searchDialog.label}</PaperDialog.Title> */}
            <PaperDialog.Content>
              <Searchbar
                autoFocus
                autoCorrect={false}
                placeholder={searchDialog.block.label}
                onChangeText={text => this.handlerSearch(text)}
                value={searchText}
              />
              <ScrollView style={styles.scrollView}>
                {searchResult.map((item, i) => {
                  return (
                    <Text
                      onPress={() => this.handlerChange(item)}
                      key={i} style={styles.item}
                    >{item.name}</Text>
                  );
                })}</ScrollView>
            </PaperDialog.Content>
          </PaperDialog>
        </Portal>
      </PaperProvider> : null
    );
  }
}

function mapStateToProps(state) {
  return {
    searchDialog: state.searchDialog,
    searchResult: state.searchResult
  };
}

SearchDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
  searchDialog: PropTypes.object,
  searchResult: PropTypes.array,
  block: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.array
};

export default connect(mapStateToProps)(SearchDialog);

const styles = StyleSheet.create({
  paper: {
    position: 'absolute',
    marginTop: 20,
    right: 0,
    left: 0,
    maxHeight: 250,
    overflow: 'hidden',
    top: Platform.Os === 'web' ? 40 : 0
  },
  scrollView: {
    maxHeight: 177,
    overflow: 'hidden',
  },
  item: {
    margin: 5
  }
});
